export const logError = (...stuffToLog: unknown[]) => {
  const isDevelopmentLog = process.env.NODE_ENV === 'development'
  if (isDevelopmentLog) {
    console.error(...stuffToLog)
  } else {
    console.error(JSON.stringify(stuffToLog))
  }
}
